<template>
  <NuxtLayout>
    <HeroHeader class="offersHeader heroHeader__StackedElements" :title-visible="false">
      <div class="heroHeader__StackedElementsContent container">
        <div class="offersHeader__Texts">
          <h1 v-text="page.title" />
  
          <div class="offersHeader__Accommodation">
            <p v-text="page.subtitle" />
          </div>
        </div>
  
        <div v-if="page.image_discount" class="offersHeader__DiscountWrapper">
          <Flare :srcset="page.image_discount" size="both" width="200" height="200" crop="fill" :alt="page.image_discount" />
        </div>
      </div>
    </HeroHeader>

    <transition name="fade">
      <OfferExpiredRibbon v-if="offerExpired" />
    </transition>
  
    <section class="offers__ListWrapper container">
      <div class="offers__ListWrapperTop">
        <Filters :data="filtersList" v-model="selectedFilters" @close="getFilters" @item-remove="getFilters" />
      </div>
  
      <div v-if="data?.results" class="offers__List">
        <OfferItem v-for="offer in data.results" :data="offer" :key="offer.id" />
      </div>

      <client-only>
        <div v-if="!initialResponseResultsLength" class="offerGroupDetail__NoResults">
          <p v-text="$t('noOffers')" />
          <Button type="nuxt-link" :to="link('OfferList')" medium>{{ $t('noOffersReturn') }}</Button>
        </div>
      </client-only>
    </section>
  </NuxtLayout>
</template>

<script setup>
  const props = defineProps({
    page: {
      type: Object
    }
  })

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })

  const { t } = useI18n();
  const { initialData, link } = useSetup();
  const { query } = useRoute();
  const selectedFilters = ref({});
  const offerExpired = ref(false);

  const queryParams = computed(() => {
    const _query = JSON.parse(JSON.stringify(query));
    for (const key of ['dates', 'date_from', 'date_to']) delete _query[key]
    return _query;
  });

  const { data, filter } = await usePaginatedData({
    endpoint: 'offer',
    fields: ['title', 'subtitle', 'image', 'image_discount', 'accommodations', 'sef', 'travel_date_from', 'travel_date_to'],
    filters: { ...queryParams.value, [FilterIdentifiersObject.OFFER_GROUP.backendId]: props.page.id },
  });

  const initialResponseResultsLength = data.value?.results?.length || 0;

  const filtersList = [
    {
      title: t('filtersTexts.region'),
      identifier: FilterIdentifiersObject.REGION.backendId,
      items: initialData.value[FilterIdentifiersObject.REGION.frontendId] ? initialData.value[FilterIdentifiersObject.REGION.frontendId] : []
    },
    {
      title: t('filtersTexts.propertyType'),
      identifier: FilterIdentifiersObject.PROPERTY_TYPE.backendId,
      items: getPropertyTypeFilters(t)
    },
    {
      title: t('filtersTexts.holidayType'),
      identifier: FilterIdentifiersObject.HOLIDAY_TYPE.backendId,
      items: initialData.value.amenities?.[FilterIdentifiersObject.HOLIDAY_TYPE.frontendId] ? initialData.value.amenities[FilterIdentifiersObject.HOLIDAY_TYPE.frontendId] : []
    },
  ];

  function getFilters() {
    setTimeout(async () => {
      filter({...selectedFilters.value, ...{[FilterIdentifiersObject.OFFER_GROUP.backendId]: props.page.id}});
    }, 0)
  }

  onMounted(() => {
    if (sessionStorage.getItem('offerExpired')) {
      offerExpired.value = true;
      setTimeout(() => {
        sessionStorage.removeItem('offerExpired');
        offerExpired.value = false;
      }, 10000);
    }
  });

  onBeforeUnmount(() => {
    if (import.meta.client) sessionStorage.removeItem('offerExpired');
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_offers.scss');
</style>